import { TabContext, TabPanel } from '@mui/lab';

import { SectionClient } from '../../Tabs/Clients/SectionClient';
import { TabsHeader } from './TabsHeader';
import { TabItem } from './types';

type TabsPanelProps = {
  tabs: TabItem[];
  selectedTab: string;
  onSelectedTabChange: (value: string) => void;
  onClose: (value: string) => void;
  onCloseAll: () => void;
  onActivityClick?: (delegatedSessionId: number) => void;
};

export function TabsPanel({
  tabs,
  selectedTab,
  onSelectedTabChange,
  onClose,
  onCloseAll,
  onActivityClick,
}: TabsPanelProps): JSX.Element {
  // Com uma aba só o fechar fica dentro do painel; a partir de duas ele passa
  // para o cabeçalho de abas.
  const hasMultipleTabs = tabs.length > 1;

  const handleClose = (value: string): void => {
    if (selectedTab === value) {
      const remaining = tabs.filter((tab) => tab.value !== value);
      onSelectedTabChange(remaining[remaining.length - 1]?.value ?? '');
    }
    onClose(value);
  };

  return (
    <TabContext value={selectedTab}>
      {hasMultipleTabs && (
        <TabsHeader
          tabs={tabs}
          onChange={onSelectedTabChange}
          onClose={handleClose}
          onCloseAll={onCloseAll}
        />
      )}
      {tabs.map((tab) => (
        <TabPanel key={tab.value} value={tab.value}>
          <SectionClient
            id={tab.id.toString()}
            sessionId={tab.sessionId}
            source={tab.source}
            userRole={tab.userRole}
            error_count={tab.errorCount}
            device={tab.device}
            started_at={tab.startedAt}
            ended_at={tab.last_activity_at}
            delegated_session_id={tab.delegatedSessionId}
            showCloseButton={!hasMultipleTabs}
            onClose={() => handleClose(tab.value)}
            onActivityClick={onActivityClick}
          />
        </TabPanel>
      ))}
    </TabContext>
  );
}
